module.exports = __webpack_public_path__ + "static/AppliedAI-2f7cca5b6398300df9a7a5dc3ef8e951.jpg";